import { methodGet, methodPatch, methodPost } from './methods';
import { API_INFO } from '../constants';

export async function addItemCart(payload) {
  const url = API_INFO + 'ecommerce/carts/add_item/';
  return methodPost(url, payload);
}

export async function removeItemCart(payload) {
  const url = API_INFO + 'ecommerce/carts/remove_item/';
  return methodPost(url, payload);
}

export async function decreaseQuantityItemCart(payload) {
  const url = API_INFO + 'ecommerce/carts/decrease_quantity_item/';
  return methodPost(url, payload);
}

export async function getCart() {
  const url = API_INFO + 'ecommerce/carts/get_active/';
  return methodGet(url);
}

export async function settingStorePickup(payload) {
  const url = API_INFO + 'ecommerce/carts/setting_store_pickup/';
  return methodPost(url, payload);
}

export async function createOrder(payload) {
  const url = API_INFO + 'storehouse/orders/';
  return methodPost(url, payload);
}

export async function getInfoRedsys(payload) {
  const url = API_INFO + 'ecommerce/carts/get_info_redsys/';
  return methodGet(url, payload);
}

export async function paymentOk(payload) {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  const url = API_INFO + 'ecommerce/carts/payment_ok/';
  return methodPost(url, payload, config);
}

export async function markOrderPaid(payload) {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  const url = API_INFO + 'ecommerce/carts/mark_order_paid/';
  return methodPost(url, payload, config);
}

export async function paymentOkContest(payload) {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  const url = API_INFO + 'ecommerce/carts/payment_ok_contest/';
  return methodPost(url, payload, config);
}

export async function errorPayment() {
  const url = API_INFO + 'ecommerce/carts/error_payment/';
  return methodPost(url);
}

export const createGiftCard = async (payload) => {
  const url = API_INFO + `ecommerce/carts/add_giftcard/`;
  return methodPost(url, payload);
};

export const deleteGiftCardCart = async (payload) => {
  const url = API_INFO + 'ecommerce/carts/remove_giftcard/';
  return methodPost(url, payload);
};

export const updateCartDetails = async (payload) => {
  const url = API_INFO + 'ecommerce/carts/update-active-cart/';
  return methodPatch(url, payload);
}

export const redsysProcessCopyDeactivateCart = async (payload) => {
  const url = API_INFO + 'ecommerce/carts/copy-and-deactivate-cart/';
  return methodPost(url, payload);
}

export const createOrderBeforePayment = async () => {
  const url = API_INFO + 'ecommerce/carts/create_order_before_payment/';
  return methodPost(url, {});
}

export const addItemsByEan = async (payload) => {
  const url = API_INFO + 'ecommerce/carts/get_add_item_by_ean/';
  return methodPost(url, payload);
}